document.addEventListener('input', function (e) {

  if (
    e.target.name === 'properties[Name 1]' ||
    e.target.name === 'properties[Name 2]'
  ) {
    e.target.value = e.target.value.toUpperCase();
  }

  /* ===============================
     NEW LOGIC FOR properties[Letters], properties[LETTERS]
     =============================== */

  if (
    e.target.name !== 'properties[Letters]' &&
    e.target.name !== 'properties[LETTERS]'
  ) return;

  const path = window.location.pathname;


  /* ---------- LOWERCASE PRODUCTS ---------- */

  const lowercaseProducts = [
    'custom-script-word-necklace',
    'custom-diamond-script-necklace',
    'custom-diamond-lowercase-necklace',
    'custom-lowercase-word-necklace'
  ];


  /* ---------- UPPERCASE PRODUCTS ---------- */

  const uppercaseProducts = [
    'custom-script-word-necklace',
    'custom-diamond-uppercase-word-necklace',
    'custom-mini-letter-necklace',
    'custom-sentiment-pendant-necklace',
    'custom-uppercase-letter-necklace',
    'custom-mini-diamond-letter-necklace-with-bezel-accent',
    'custom-mini-letter-necklace-with-bezel-accent',
    'custom-mini-letter-fixed-necklace',
    'mini-bezel-tennis-necklace-with-custom-diamond-word-accent',
    'custom-mini-letter-mini-bezel-bracelet',
    'custom-large-heart-initial-necklace',
    'engravable-heart-nameplate-necklace',
    'engravable-nameplate-heart-pendant-necklace',
    'custom-mini-letter-mini-bezel-bracelet-1'
  ];

  if (lowercaseProducts.some(handle => path.includes(handle))) {
    e.target.value = e.target.value.toLowerCase();
  }

  if (uppercaseProducts.some(handle => path.includes(handle))) {
    e.target.value = e.target.value.toUpperCase();
  }

});